import { Container } from "react-bootstrap";

function PrivacyPolicy() {
  return (
    <Container className="py-4 policy-page">
      <h2 className="mb-2">Privacy Policy</h2>
      <p className="text-muted small">Last updated: 27 April 2026</p>

      <p>
        Dial Tutors (“we”, “our”, “us”) operates the website
        <a href="https://dialtutors.in"> dialtutors.in</a> and connects students and parents
        with home tutors. This Privacy Policy explains what information we collect, how we
        use it, with whom we share it, and the rights you have over your data. By using our
        platform you consent to the practices described below.
      </p>

      <h5 className="mt-4">1. Information we collect</h5>
      <ul>
        <li>
          <strong>Account information:</strong> name, email address, phone number, password
          (stored only as a salted hash), and role (student / parent / tutor).
        </li>
        <li>
          <strong>Profile information:</strong> for students — grade, board, city, locality;
          for tutors — qualifications, experience, photo, bio, subjects taught, fees, and
          weekly availability.
        </li>
        <li>
          <strong>Booking &amp; usage data:</strong> demo bookings, hire records, attendance,
          ratings and reviews, wallet transactions, login times, and IP address.
        </li>
        <li>
          <strong>Payment information:</strong> when you pay for a booking, top-up, or
          settlement, you transact directly with our payment gateway partner. We receive only
          a transaction reference, amount, and status — we do not see or store your card,
          UPI, or net-banking credentials.
        </li>
        <li>
          <strong>Communication:</strong> messages you send to support and any feedback you
          submit through the site.
        </li>
      </ul>

      <h5 className="mt-4">2. How we use your information</h5>
      <ul>
        <li>To create and operate your account and match students with suitable tutors.</li>
        <li>To process bookings, demos, hires, attendance, payments, and settlements.</li>
        <li>To send service notifications (booking confirmations, payment receipts,
          attendance updates, password resets).</li>
        <li>To verify tutor identity and credentials before approval.</li>
        <li>To investigate disputes, prevent abuse, and comply with legal obligations.</li>
        <li>To improve the platform — debugging, analytics, and feature development.</li>
      </ul>

      <h5 className="mt-4">3. Sharing of information</h5>
      <p>We share your data only with:</p>
      <ul>
        <li>
          <strong>Tutors and students you actively engage with</strong> — a tutor sees the
          name, contact, and learning needs of students who book them, and a student sees the
          tutor’s public profile and contact only after a booking is created.
        </li>
        <li>
          <strong>Payment gateway partners</strong> (such as PayU, Razorpay, or similar
          regulated providers) — solely to process the transaction you initiate.
        </li>
        <li>
          <strong>Hosting and infrastructure providers</strong> who host our servers under
          confidentiality obligations.
        </li>
        <li>
          <strong>Government authorities</strong> when required by law, court order, or to
          protect against fraud or harm.
        </li>
      </ul>
      <p>We do not sell or rent your personal data to third parties for marketing.</p>

      <h5 className="mt-4">4. Cookies and session data</h5>
      <p>
        We use a single first-party session cookie to keep you signed in while you use the
        site. We do not use third-party advertising or tracking cookies. You can clear cookies
        in your browser at any time, but doing so will sign you out.
      </p>

      <h5 className="mt-4">5. Children and minors</h5>
      <p>
        Many of our students are minors. Accounts for users under 18 must be created and
        operated by a parent or legal guardian, who is responsible for the minor’s use of the
        platform and for providing consent for the collection of the child’s academic and
        contact information.
      </p>

      <h5 className="mt-4">6. Data security</h5>
      <p>
        We use HTTPS for all browser-to-server traffic, store passwords as bcrypt hashes
        (never in plain text), restrict server access to authorised personnel, and rely on
        regulated payment partners for cardholder data. While we implement reasonable
        technical and organisational measures, no system can be guaranteed to be 100% secure.
      </p>

      <h5 className="mt-4">7. Data retention</h5>
      <p>
        We retain account, booking, and payment records for as long as your account is active
        and for a reasonable period afterwards as required by Indian tax and accounting law
        (typically up to 8 years for financial records). You may request deletion of optional
        profile fields at any time.
      </p>

      <h5 className="mt-4">8. Your rights</h5>
      <ul>
        <li>Access the personal data we hold about you.</li>
        <li>Correct any inaccurate information from your dashboard or by contacting support.</li>
        <li>Delete your account — write to us and we will close it after settling any
          pending dues.</li>
        <li>Withdraw consent for non-essential processing.</li>
      </ul>

      <h5 className="mt-4">9. Changes to this policy</h5>
      <p>
        We may update this policy from time to time. The updated version will be posted on
        this page with a new “Last updated” date. Material changes will also be notified via
        email or an in-app banner.
      </p>

      <h5 className="mt-4">10. Grievance officer / contact</h5>
      <p>
        For any privacy concern, request, or complaint, please contact:
      </p>
      <ul className="list-unstyled">
        <li><strong>Email:</strong> <a href="mailto:support@dialtutors.in">support@dialtutors.in</a></li>
        <li><strong>Phone:</strong> <a href="tel:7448337000">7448337000</a></li>
      </ul>
    </Container>
  );
}

export default PrivacyPolicy;
